import { Spin } from "antd";

const Loading = () => <Spin tip="Loading..." style={{width: '100%'}} data-testid="spinner" />;

export default Loading;
